


































































import Vue from 'vue';
import {
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
} from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { required, maxLength } from 'vuelidate/lib/validators';
import { ExtendMixins } from '@/services';

interface Data {
  isLoading: boolean;
  confirmBeforeClose: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  note: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
).extend({
  name: 'AddClaimNote',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      confirmBeforeClose: true,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      note: '',
    };
  },
  beforeMount() {
    this.showErrorModel.note = false;
  },
  validations: {
    note: {
      required,
      maxLength: maxLength(256),
    },
  },
  computed: {
    selectedTransactionId(): string {
      return this.params.transactionId.toString();
    },
    noteErrors(): string[] {
      const formField = 'note';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'add-claim-note_error_note_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'add-claim-note_error_note_length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      this.showErrorMessage = false;
      this.confirmBeforeClose = true;
    },
    addTransactionNote(): void {
      this.isLoading = true;
      this.$store
        .dispatch('addTransactionNote', {
          id: this.selectedTransactionId,
          note: this.note,
        })
        .then(() => {
          this.refreshTransactions();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshTransactions(): void {
      this.$store
        .dispatch('getAccountTransactions', this.$route.params.id)
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'add-claim-note_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
